// ─── ALQOS™ Logger Centralizado ───────────────────────────────
// Registra acciones del sistema con usuario, fecha, módulo y cambios
// Reutilizable en cualquier módulo. No modifica datos existentes.

const STORAGE_LOG = 'alqos_log_acciones';

const logStorage = {
  get: () => { try { return JSON.parse(localStorage.getItem(STORAGE_LOG) || '[]'); } catch { return []; } },
  set: (val) => { try { localStorage.setItem(STORAGE_LOG, JSON.stringify(val)); } catch (e) { console.error('[LOGGER] Error al guardar log', e); } },
};

/**
 * Registra una acción en el log centralizado de ALQOS™
 * @param {string} modulo - Nombre del módulo ("FMEA", "NC", "FSC", etc.)
 * @param {string} accion - Tipo de acción ("crear", "editar", "eliminar", "cerrar", "desvio", etc.)
 * @param {object} datos - { entidad, idEntidad, antes, despues }
 * @param {object} usuario - { nombre, rol }
 */
export function logAction(modulo, accion, datos = {}, usuario = {}) {
  try {
    const logs = logStorage.get();
    const entrada = {
      id: Math.floor(Date.now()),
      fecha: new Date().toISOString(),
      fechaLegible: new Date().toLocaleString('es-AR'),
      modulo,
      accion,
      entidad: datos.entidad || "",
      idEntidad: datos.idEntidad || "",
      usuario: usuario?.nombre || "Sistema",
      rol: usuario?.rol || "",
      antes: datos.antes || null,
      despues: datos.despues || null,
      detalle: datos.detalle || "",
    };
    // Mantener máximo 500 entradas para no saturar localStorage
    const nuevos = [entrada, ...logs].slice(0, 10000);
    logStorage.set(nuevos);
  } catch (e) {
    console.error('[LOGGER] Error al registrar acción', e);
  }
}

/**
 * Obtiene el log completo o filtrado
 * @param {string} modulo - Opcional, filtra por módulo
 * @param {number} limite - Cantidad máxima de entradas
 */
export function getLogs(modulo = null, limite = 100) {
  try {
    const logs = logStorage.get();
    const filtrados = modulo ? logs.filter(l => l.modulo === modulo) : logs;
    return filtrados.slice(0, limite);
  } catch { return []; }
}

/**
 * Exporta el log completo como CSV
 */
export function exportarLogCSV() {
  try {
    const logs = logStorage.get();
    if (!logs.length) { alert("No hay registros en el log."); return; }
    const keys = ["fecha", "fechaLegible", "modulo", "accion", "entidad", "idEntidad", "usuario", "rol", "detalle"];
    const csv = [keys.join(","), ...logs.map(l => keys.map(k => `"${String(l[k] || "").replace(/"/g, '""')}"`).join(","))].join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `ALQOS_Log_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  } catch (e) { console.error('[LOGGER] Error exportar log', e); }
}

/**
 * Limpia el log (solo admin)
 */
export function limpiarLog() {
  logStorage.set([]);
}